<template>
    <v-dialog
        v-model="isDialogOpen"
        max-width="500"
        transition="dialog-bottom-transition"
    >
        <v-card>
            <v-container class="app-container">
                <v-card-title
                    class="justify-center font-weight-bold text-uppercase"
                >
                    {{ $t('contacts') }}
                </v-card-title>

                <v-row v-for="contact in contacts" :key="contact.id">
                    <v-col cols="12">
                        <v-card-subtitle>
                            {{ contact.name || $t('contact') }}
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <v-card-text>
                            <span class="font-weight-bold">{{ $t('firstName') }}:</span>
                            {{ contact.first_name + ' ' + contact.last_name }}
                        </v-card-text>
                        <v-card-text>
                            <span class="font-weight-bold">Email:</span>
                            <a class="text-underline font-weight-black" :href="'mailto:' + contact.email">
                                {{ contact.email }}
                            </a>
                        </v-card-text>
                        <v-card-text>
                            <span class="font-weight-bold">{{ $t('telephone') }}:</span>
                            <a class="text-underline font-weight-black" :href="'tel:' + contact.phone">
                                {{ contact.phone }}
                            </a>
                        </v-card-text>
                        <v-card-text v-if="contact.phone_2">
                            <span class="font-weight-bold">{{ $t('telephone') }}:</span>
                            <a class="text-underline font-weight-black" :href="'tel:' + contact.phone_2">
                                {{ contact.phone_2 }}
                            </a>
                        </v-card-text>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    import DialogRemote from '../../mixins/DialogRemote';

    export default {
        name: 'ContactsDialog',
        mixins: [DialogRemote],
        props: {
            contacts: {
                required: false,
                type: Array,
                default: () => [],
            },
        },
    }
</script>

<style scoped>

</style>
